export default "__VITE_ASSET__DKCkYjej__"